import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Container, Form } from "react-bootstrap";
import { motion } from "framer-motion";

export const Contact = () => {
	const form = useRef();
	const [sending, setSending] = useState(false);
	const [sent, setSent] = useState(false);

	const validateInput = () => {
		const usernameInput = form.current.elements.namedItem("user_name");
		const emailInput = form.current.elements.namedItem("user_email");
		const messageInput = form.current.elements.namedItem("message");

		const username = usernameInput.value;
		const email = emailInput.value;
		const message = messageInput.value;

		const emailRegex = new RegExp(
			"[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$",
			"i"
		);
		let ready = true;

		if (username.trim() === "") {
			usernameInput.classList.remove("border-light");
			usernameInput.classList.add("border-danger");
			setTimeout(() => {
				usernameInput.classList.remove("border-danger");
				usernameInput.classList.add("border-light");
			}, 3000);
			ready = false;
		}
		if (!emailRegex.test(email)) {
			emailInput.classList.remove("border-light");
			emailInput.classList.add("border-danger");
			setTimeout(() => {
				emailInput.classList.remove("border-danger");
				emailInput.classList.add("border-light");
			}, 3000);
			ready = false;
		}
		if (message.trim() === "") {
			messageInput.classList.remove("border-light");
			messageInput.classList.add("border-danger");
			setTimeout(() => {
				messageInput.classList.remove("border-danger");
				messageInput.classList.add("border-light");
			}, 3000);
			ready = false;
		}
		return ready;
	};

	const sendEmail = (e) => {
		e.preventDefault();
		if (!validateInput()) {
			return;
		}
		const lastSenttime = localStorage.getItem("emailCache");
		const allowedTimePeriod = 36000000;

		if (!lastSenttime || Date.now() - lastSenttime > allowedTimePeriod) {
			setSending(true);
			emailjs
				.sendForm(
					"service_vuobtx2",
					"template_7694wk7",
					form.current,
					"9bV6Dci7mKD-QLz46"
				)
				.then(
					(result) => {
						document.getElementById("myForm").reset();
						setSending(false);
						setSent(true);
						setTimeout(() => {
							setSent(false);
						}, 5000);
					},
					(error) => {
						console.log(error.text);
					}
				);
			localStorage.setItem("emailCache", Date.now());
		} else {
			alert(
				"Looks like you have recently sent an email, check back again."
			);
		}
	};

	return (
		<motion.div
			className="vih"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1 }}
		>
			<Container id="widthRes" className="pb-5 pt-5">
				<h2 className="text-light text-center">
					Lets work <span className="text-blue">together!</span>
				</h2>
				<h4 className="text-light text-center">
					Contact <span className="text-blue">Me</span>
				</h4>
				<hr className="text-white mb-5" />
				<Form
					id="myForm"
					ref={form}
					onSubmit={sendEmail}
					// onSubmit={testSend}
					className="m-5"
				>
					<Form.Group className="mb-5">
						<Form.FloatingLabel label="Name:" className="pt-2">
							<Form.Control
								name="user_name"
								id="formDetail"
								type="text"
								className="border border-light border-3"
								placeholder="Let me know who you are!"
							/>
						</Form.FloatingLabel>
					</Form.Group>
					<Form.Group className="mb-4">
						<Form.FloatingLabel
							label="Email address:"
							className="pt-2"
						>
							<Form.Control
								type="email"
								id="formDetail"
								name="user_email"
								className="border border-light border-3"
								placeholder="How can I reach back to you"
							/>
						</Form.FloatingLabel>
						<Form.Text className="text-muted">
							Your email will <strong>never</strong> be shared
							with anyone else.
						</Form.Text>
					</Form.Group>
					<Form.Group className="mb-5">
						<Form.FloatingLabel
							label="Enter message here:"
							className="pt-2"
						>
							<Form.Control
								as="textarea"
								id="formDetail"
								type="text"
								className="border border-light border-3 custom-textrarea "
								name="message"
								placeholder="message here"
							/>
						</Form.FloatingLabel>
					</Form.Group>

					<Form.Control
						id="subBtn"
						disabled={sending || sent}
						className="d-none d-md-block bg-dark text-light m-auto w-50 p-3"
						type="submit"
						value={
							sending
								? "Sending..."
								: sent
								? "Message Sent!"
								: "Send Message"
						}
					/>
					<Form.Control
						id="subBtn"
						disabled={sending || sent}
						className="d-md-none bg-dark text-light m-auto p-3"
						type="submit"
						value={
							sending
								? "Sending..."
								: sent
								? "Message Sent!"
								: "Send Message"
						}
					/>
				</Form>
			</Container>
		</motion.div>
	);
};
